module.exports = __webpack_public_path__ + "static/media/reservation-title-inquiry.64873e91.png";